import { computed, defineComponent, onMounted } from 'vue';
import SVG from '@dts/shared/src/assets/svg';
import Typography from '@/components/TextFormat/FormatElements/Typography';
import styles from './index.module.scss';
import xssInstance from '@dts/shared/src/utils/xss';

const NotificationDrawer = defineComponent({
  props: {
    showDrawer: {
      type: Boolean,
    },
    notification: {
      type: Object,
      require: true,
      default: () => {},
    },
  },

  emits: ['update:showNotificationDrawer'],
  setup: (props, context) => {
    const Icon = computed(() => {
      const iconMap = {
        1: <SVG.UserCenterIconTypeUpdate />,
        2: <SVG.UserCenterIconTypePopular />,
        3: <SVG.UserCenterIconTypeGrowth />,
      };
      return iconMap[props.notification?.type] || null;
    });

    const colseUserCenter = () => {
      context.emit('update:showNotificationDrawer', false);
    };
    onMounted(() => {});
    return () => (
      <>
        <div class={styles.notification}>
          <div class={styles.topTitle}>
            <div class={styles.left}>
              {Icon.value}
              <div class={styles.text}>
                <Typography.Text size={18} weight={700}>
                  {props.notification?.type === 1
                    ? 'DTS Update'
                    : props.notification?.type === 2
                      ? 'Popular Topic'
                      : 'Personal Growth'}
                </Typography.Text>
              </div>
            </div>

            <div class={styles.close} onClick={colseUserCenter}>
              <SVG.UserCenterClose />
            </div>
          </div>{' '}
          <div
            class={styles.notificationContent}
            v-html={xssInstance.process(props?.notification?.message)}
          ></div>
        </div>
      </>
    );
  },
});
export default NotificationDrawer;
